import React from 'react';
import { SvgIcon } from '@mui/material';
import { ReactComponent as StatusDotBlue } from 'assets/images/icons/dots/statusdot-blue.svg';
import { IconProps } from 'types/icon';

const StatusDotBlueIcon: React.FC<IconProps> = ({
    width = '18px',
    height = '18px',
}) => {
    return (
        <SvgIcon
            component={StatusDotBlue}
            inheritViewBox
            style={{ width, height }}
        />
    );
};

export default StatusDotBlueIcon;
